import React from 'react';
import { RoutedContent } from './pages';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import moment from 'moment';
import localization from 'moment/locale/hr';
import hrHR from 'antd/es/locale/hr_HR';
import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import 'remixicon/fonts/remixicon.css'
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import { faLayerGroup, faMapMarked, faRulerCombined, faBus, faTrain, faParking,
   faRoute, faCity, faWalking, faBicycle,faSort, faWheelchair, faInfoCircle, faToilet, faBaby, faTrashAlt, faChair, faCalendarAlt, faMoneyCheck, faLocationArrow,
   faVolumeUp, faTicketAlt, faCashRegister, faStore, faLightbulb, faVideo, faShieldAlt, faPhoneVolume, faRoad, faRestroom, faDirections,faMapMarkerAlt, faMapMarkedAlt,
    faMap, faImage, faAtlas, faRulerVertical, faStickyNote, faSchool, faUserGraduate, faShuttleVan, faBusAlt, faClock, faCalendarDay,faPrint, faSignOutAlt, faChartBar, faCarCrash, faTasks,
    faLeaf, faUtensils, faCompass, faCouch, faChargingStation, faArchway, faWind, faFaucet, faTools
   } from '@fortawesome/free-solid-svg-icons'
import { UserContextProvider } from './contexts/UserContext';
import { GlobalContextProvider } from './contexts/GlobalContext';

library.add(faLayerGroup, faMapMarked, faRulerCombined, faBus, faTrain, faParking, faRoute, faDirections,
   faCity, faWalking, faBicycle,faSort, faWheelchair, faInfoCircle, faToilet, faBaby, faTrashAlt, faChair, faCalendarAlt, faMoneyCheck, faLocationArrow,
   faVolumeUp, faTicketAlt, faCashRegister, faStore, faLightbulb, faVideo, faShieldAlt, faPhoneVolume,  faRoad, faRestroom,faMapMarkerAlt, faMapMarkedAlt, faMap, faImage, faAtlas,
   faRulerVertical, faStickyNote, faSchool, faUserGraduate, faShuttleVan, faBusAlt, faClock, faCalendarDay,faPrint, faSignOutAlt, faChartBar, faCarCrash, faTasks, faLeaf, faUtensils, faCompass, faCouch,
   faChargingStation, faArchway, faWind, faFaucet, faTools)


moment.locale("hr");
moment.updateLocale('hr', localization);

function App() {
  return (
    <div className="App">
      <GlobalContextProvider>
        <UserContextProvider>
          <ConfigProvider locale={hrHR}>
            <Router>
              <RoutedContent />
            </Router>
          </ConfigProvider>
        </UserContextProvider>
      </GlobalContextProvider>
    </div>
  );
}

export default App;
